import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    hangerItemsReference: [],
    currentPage: 1,
    pageCount: 0,
    isLoading: true,
    packageOptions: [],
    pdfView: false,
    error: "",
    highlightHangerState:'',
    url:'',
    package: { label: '', value: '' },
    packageDetails: {},
    replaceHangerId: 0,
    drawingLoading: false,
    hangerDrawing: {
        name: "",
        value: "",
        error: "",
        showError: "",
    },
}

const listHangerItems = createNamespacer("HANGER_ITEMS_LIST")

const listHangerItemsReducer = createReducer(initialState, {
    [listHangerItems("SET_HANGER_ITEMS")]:(state, action) => {
        return {
            ...state,
            hangerItemsReference: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [listHangerItems("SET_PACKAGE_OPTION")]: (state, action) => {
        return {
            ...state,
            package: action.payload.value,
        }

    },
    [listHangerItems("SET_REPLACE_HANGER_ID")]:(state, action) => {
        return {
            ...state,
            replaceHangerId: action.payload.id,
        }
    },
    [listHangerItems("SET_REPLACE_HANGER_DRAWING")]:(state, action) => {
        return {
            ...state,
            hangerDrawing:{
                ...state.hangerDrawing,
                value: action.payload.value,
                name: action.payload.value.name,
            },
        }
    },
    [listHangerItems("CLEAR_REPLACE_FORM")]: (state, action) => {
        return {
            ...state,
            hangerDrawing: {
                ...initialState.hangerDrawing,
            }
        }
    },
    [listHangerItems("SET_HANGER_PDF")]: (state, action) => {
        return {
            ...state,
            url: action.payload.value.drawing,
        }
    },
    [listHangerItems("SET_DRAWING_LOADING")]: (state, action) => {
        return {
            ...state,
            drawingLoading: action.payload.value,
        }
    },
    [listHangerItems("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [listHangerItems("SET_LOADING")]:(state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [listHangerItems("HIGHLIGHT_HANGER_ITEM")]: (state, action) => {
        return {
            ...state,
            highlightHangerState: action.payload.hangerItem,
        }
    },
    [listHangerItems("SET_PAGE")]:(state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [listHangerItems("SET_PACKAGE_OPTIONS")]:(state, action) => {
        return {
            ...state,
            packageOptions: [
                ...state.packageOptions,
                ...action.payload.value
            ],
        }
    },
    [listHangerItems("CLEAR_PACKAGE_OPTIONS")]:(state, action) => {
        return {
            ...state,
            packageOptions: initialState.packageOptions,
        }
    },
    [listHangerItems("SET_PACKAGE_DETAILS")]:(state, action) => {
        return {
            ...state,
            packageDetails: action.payload.value,
        }
    },
    [listHangerItems("SET_PDF_VIEW")]: (state, action) => {
        return {
            ...state,
            pdfView: action.payload.value,
        }
    },
    [listHangerItems("CLEAR_PDF_URL")]: (state, action) => {
        return {
            ...state,
            url: "",
        }
    },
    [listHangerItems("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
});

export default listHangerItemsReducer